import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SearchModule } from 'src/app/components/search/search-module.module';
import { DirectivesModule } from 'src/app/directives/directives.module';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { UserSearchDialogComponent } from './user-search-dialog/user-search-dialog.component';
import { UserSearchComponent } from './user-search.component';
import { UserSearchInputComponent } from '@smartcharge/portal/features/user-search/user-search.component';

@NgModule({
  imports: [
    CommonModule,
    MatAutocompleteModule,
    MatInputModule,
    ReactiveFormsModule,
    FormsModule,
    PipesModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatTooltipModule,
    DirectivesModule,
    SearchModule,
    UserSearchInputComponent
  ],
  declarations: [UserSearchComponent, UserSearchDialogComponent],
  exports: [UserSearchComponent]
})
export class UserSearchModule {}
